const openButton = document.querySelector('.mobile-menu-open > img');
const closeButton = document.querySelector('.mobile-menu-close > img');

openButton.addEventListener('click', () => {
  openButton.style.display = 'none';
  closeButton.style.display = 'block';
  document.querySelector('.hamburger').style.display = 'block';
  document.querySelector('.hamburger').style.visibility = 'visible';
  document.querySelector('.hamburger').style.opacity = '1';
  document.querySelector('header').style.backgroundColor = '#191919';
});

closeButton.addEventListener('click', () => {
  openButton.style.display = 'block';
  closeButton.style.display = 'none';
  document.querySelector('.hamburger').style.display = 'none';
  document.querySelector('.hamburger').style.visibility = 'hidden';
});

document.querySelectorAll('a').forEach((el) => {
  if (el.getAttribute('href') === '#contact' && el.getAttribute('class') === 'text-uppercase') {
    el.addEventListener('click', () => {
      openButton.style.display = 'block';
      closeButton.style.display = 'none';
      document.querySelector('.hamburger').style.display = 'none';
      document.querySelector('.hamburger').style.visibility = 'hidden';
    });
  }
});
